"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'reports.period.lastWeek': 'Última Semana',
    'reports.period.lastMonth': 'Último Mes',
    'reports.period.last3Months': 'Últimos 3 Meses',
    'reports.period.lastYear': 'Último Año',
    'reports.period.allTime': 'Todo el Tiempo',
    'reports.period.custom': 'Rango Personalizado',
};
